import React from 'react';
import styles from './Contact.css';
import contactImg from '../../../assets/letter.jpg';
import CallToActionBtn from "../../CallToActionBtn/CallToActionBtn";

const oneliners = {
    1: "Milionowe kontrakty zgłaszać tutej..."
};

const Contact = (props) => (
    <div className={styles.mainDiv}>
        <img src={contactImg} className={styles.mainImg} alt="contact Maciej"/>
        <h1 className={styles.title}>KONTAKT</h1>
        <p className={styles.text}>{oneliners[1]}</p>
        <CallToActionBtn facebook={true} />
    </div>
);

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Mobile/Contact/Contact.js